// constants from https://github.com/pnorental/conti/blob/master/src/conti/consts.go 

const casingDisposals = {
    "COLLECTION_BY_CAG": "Collected by Continental",
    "PURCHASE": "Purchase by Vendor",
    "REMAINS_IN_CUSTOMER_STOCK": "into Customer Stock",
    "REMAINS_IN_STOCK": "into Partner Stock",
    "REMAINS_ON_VEHICLE": "Remains on vehicle",
    "REMAINS_WITH_CUSTOMER": "Customer",
    "SCRAP": "Scrap",
    "SEND_TO_MANUFACTURER": "Customer Claim",
}

export const CasingDisposals = { ...casingDisposals };

export const CasingDisposal = function (disposal) {
    return casingDisposals[disposal] ? casingDisposals[disposal] : null
}
